/*
 * Saved lists v2 (NZS-SAVE-SHEET-0905): one store, named collections, Shop-app-style save sheet.
 *
 * Storage: localStorage nzs_saved_v2 = {"v":2,"lists":[{"k":"favourites","n":"Saved","ids":[]},{"k":"c_<ts>","n":"...","ids":[]}]}
 *   ids are product ids, newest first. Legacy keys eurus_favourites / eurus_wishlist are read once (migration)
 *   and eurus_favourites keeps being written as the UNION so the header count, card bindings and the
 *   logged-in seed (window.Eurus.savedSeed) keep working unchanged.
 * Reactivity: sets.favourites is a reactive Set (union). has() tracks ONE key, so a save re-runs only that
 *   product's bindings, never every card x every saved id. The Set is mutated (add/delete), never replaced.
 * Surfaces: card hearts + PDP overlay ([data-nzs-save]) -> save() = add to "Saved" + open the sheet;
 *   the sheet toggles per collection and creates new ones; /pages/favourites renders chips + a grid per list.
 */
if (!window.Eurus.loadedScript.has('saved-lists.js')) {
  window.Eurus.loadedScript.add('saved-lists.js');

  const KEY = 'nzs_saved_v2';
  const LEGACY = ['eurus_favourites', 'eurus_wishlist'];
  const SYNC_ENDPOINT = null; // account write-sync (app proxy). Null => localStorage only.
  const num = (v) => Number(v) || 0;
  const readJSON = (k, fb) => { try { const v = JSON.parse(localStorage.getItem(k)); return v == null ? fb : v; } catch (e) { return fb; } };
  const write = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/></svg>'; /* the store's save (bookmark) glyph */
  const PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const FOLDER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>';

  function load() {
    const v2 = readJSON(KEY, null);
    if (v2 && Array.isArray(v2.lists) && v2.lists.length) {
      return v2.lists.map((l) => ({ k: String(l.k), n: String(l.n || 'Saved').slice(0, 40), ids: (l.ids || []).map(num).filter(Boolean) }));
    }
    const ids = [];
    LEGACY.forEach((k) => (Array.isArray(readJSON(k, [])) ? readJSON(k, []) : []).map(num).filter(Boolean).forEach((id) => { if (!ids.includes(id)) ids.push(id); }));
    return [{ k: 'favourites', n: 'Saved', ids }];
  }

  /* the last tapped save control: focus-return target + product title/image for the sheet header */
  let lastTrigger = null, lastMeta = { title: '', image: '' };
  function metaFromBtn(btn) {
    let title = btn.getAttribute('data-save-title') || '', image = btn.getAttribute('data-save-image') || '';
    if (!title || !image) {
      const card = btn.closest('.pcard, .nzs-sw__card, .nzs-sib, .card-product, [data-product-card], .x-product-card, .nzs-bs__card, li, article');
      if (card) {
        if (!image) { const im = card.querySelector('img'); if (im) image = im.currentSrc || im.src || ''; }
        if (!title) { const tt = card.querySelector('.x-card-title, .pcard__title, .card__heading, .nzs-sw__title, .nzs-bs__title, .card-info a[href*="/products/"]'); if (tt) title = (tt.textContent || '').trim(); }
      }
    }
    return { title, image };
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.x-save-btn, .nzs-sv__btn, [data-nzs-save]');
    if (!b) return;
    lastTrigger = b; lastMeta = metaFromBtn(b);
  }, true);

  /* ---------- the sheet (quick-add panel shell: .nzs-qa / .nzs-qa-bd, bottom sheet on touch, modal on desktop) ---------- */
  const sheet = (() => {
    let bd, panel, overlay, pid = 0;
    const MQ = '(max-width:760px), (hover:none) and (pointer:coarse)';
    const store = () => Alpine.store('xSaved');
    function build() {
      if (panel) return;
      bd = document.createElement('div'); bd.className = 'nzs-qa-bd nzs-svs-bd';
      panel = document.createElement('div'); panel.className = 'nzs-qa nzs-svs';
      document.body.appendChild(bd); document.body.appendChild(panel);
      bd.addEventListener('click', close);
      panel.addEventListener('click', onClick);
      panel.addEventListener('submit', onSubmit);
      if (window.nzsOverlay && window.nzsOverlay.enhance) {
        overlay = window.nzsOverlay.enhance({
          root: panel, key: 'save-sheet', label: 'Save to a collection',
          onOpen: () => { bd.classList.add('is-in'); panel.classList.add('is-in'); },
          onClose: () => { bd.classList.remove('is-in'); panel.classList.remove('is-in'); }
        });
      }
    }
    function render(focusK) {
      const st = store();
      const rows = st.cols.map((c) => {
        const on = c.ids.includes(pid), n = c.ids.length;
        return '<li><button type="button" class="nzs-svs__row" data-k="' + esc(c.k) + '" aria-pressed="' + on + '">' +
          '<span class="nzs-svs__ic">' + (c.k === 'favourites' ? HEART : FOLDER) + '</span>' +
          '<span class="nzs-svs__name">' + esc(c.n) + '<small>' + n + (n === 1 ? ' item' : ' items') + '</small></span>' +
          '<span class="nzs-svs__heart">' + HEART + '</span></button></li>';
      }).join('');
      panel.innerHTML =
        '<button type="button" class="nzs-qa__close" aria-label="Close"><span class="nzs-qa__close-x">&#10005;</span></button>' +
        '<div class="nzs-qa__head' + (lastMeta.image ? '' : ' nzs-qa__head--noimg') + '">' +
          (lastMeta.image ? '<img class="nzs-qa__thumb" src="' + esc(lastMeta.image) + '" alt="">' : '') +
          '<div><div class="nzs-qa__t">' + esc(lastMeta.title || 'Saved') + '</div><div class="nzs-svs__sub">Saved. Pick a collection:</div></div></div>' +
        '<div class="nzs-qa__body"><ul class="nzs-svs__list">' + rows +
          '<li><button type="button" class="nzs-svs__row" data-new><span class="nzs-svs__ic nzs-svs__ic--plus">' + PLUS + '</span><span class="nzs-svs__name">Create collection</span></button></li>' +
          '<li><form class="nzs-svs__form" hidden><input class="nzs-svs__in" type="text" maxlength="40" placeholder="Collection name" aria-label="Collection name"><button type="submit" class="nzs-svs__go">Create</button></form></li>' +
        '</ul><a class="nzs-svs__all" href="/pages/favourites">View all saved</a></div>';
      if (focusK) {
        const b = panel.querySelector('[data-k="' + focusK + '"]');
        if (b) { b.focus({ preventScroll: true }); const h = b.querySelector('.nzs-svs__heart'); if (h) h.classList.add('is-pop'); }
        panel.classList.add('nzs-svs--still'); /* no row entrance replay on a toggle re-render */
      } else panel.classList.remove('nzs-svs--still');
    }
    function onClick(e) {
      const row = e.target.closest('[data-k]');
      if (row) { const st = store(), k = row.getAttribute('data-k'); st.inList(k, pid) ? st.remove(k, pid) : st.add(k, pid); render(k); return; }
      if (e.target.closest('[data-new]')) { const f = panel.querySelector('.nzs-svs__form'); f.hidden = false; f.querySelector('input').focus(); return; }
      if (e.target.closest('.nzs-qa__close')) close();
    }
    function onSubmit(e) {
      e.preventDefault();
      const st = store(), k = st.createList(panel.querySelector('.nzs-svs__in').value);
      if (k) { st.add(k, pid); render(k); }
    }
    function open(id, trigger) {
      build(); pid = id; render();
      const m = window.matchMedia(MQ).matches;
      panel.classList.toggle('is-sheet', m); panel.classList.toggle('nzs-qa--modal', !m);
      if (overlay) overlay.open({ trigger: trigger || undefined });
      else { bd.classList.add('is-in'); panel.classList.add('is-in'); }
    }
    function close() { if (overlay) overlay.close(); else { bd.classList.remove('is-in'); panel.classList.remove('is-in'); } }
    return { open, close };
  })();

  /* ---------- NZS-SAVE-ASK-0906: in-page ask dialog (same .nzs-qa shell as the sheet) instead of the native prompt / confirm ---------- */
  const ask = (() => {
    let bd, panel, overlay, resolve = null, mode = 'text', closing = false;
    const MQ = '(max-width:760px), (hover:none) and (pointer:coarse)';
    const cancelValue = () => (mode === 'confirm' ? false : null);
    function finish(v) {
      const r = resolve; resolve = null;
      if (!closing) {
        closing = true;
        if (overlay) overlay.close(); else { bd.classList.remove('is-in'); panel.classList.remove('is-in'); }
        closing = false;
      }
      if (r) r(v);
    }
    function submit() {
      if (mode === 'confirm') return finish(true);
      const inp = panel.querySelector('.nzs-ask__in'), v = (inp.value || '').trim();
      if (!v) { inp.setAttribute('aria-invalid', 'true'); inp.focus({ preventScroll: true }); return; }
      finish(v);
    }
    function build() {
      if (panel) return;
      bd = document.createElement('div'); bd.className = 'nzs-qa-bd nzs-ask-bd';
      panel = document.createElement('div'); panel.className = 'nzs-qa nzs-ask';
      document.body.appendChild(bd); document.body.appendChild(panel);
      bd.addEventListener('click', () => finish(cancelValue()));
      panel.addEventListener('click', (e) => {
        if (e.target.closest('.nzs-qa__close') || e.target.closest('[data-cancel]')) finish(cancelValue());
        else if (mode === 'confirm' && e.target.closest('.nzs-ask__btn--go')) submit();
      });
      panel.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
      panel.addEventListener('input', (e) => { if (e.target.classList.contains('nzs-ask__in')) e.target.removeAttribute('aria-invalid'); });
      /* Esc: nzsOverlay closes the panel itself (onClose resolves); this also covers the no-overlay fallback */
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && resolve) finish(cancelValue()); });
      if (window.nzsOverlay && window.nzsOverlay.enhance) {
        overlay = window.nzsOverlay.enhance({
          root: panel, key: 'save-ask', label: 'Collection',
          onOpen: () => { bd.classList.add('is-in'); panel.classList.add('is-in'); },
          onClose: () => { bd.classList.remove('is-in'); panel.classList.remove('is-in'); if (resolve) finish(cancelValue()); }
        });
      }
    }
    function render(o) {
      const row = '<div class="nzs-ask__row"><button type="button" class="nzs-ask__btn" data-cancel>Cancel</button>' +
        '<button type="submit" class="nzs-ask__btn nzs-ask__btn--go' + (o.danger ? ' nzs-ask__btn--danger' : '') + '">' + esc(o.cta || 'OK') + '</button></div>';
      const body = mode === 'confirm'
        ? '<p class="nzs-ask__body">' + esc(o.body || '') + '</p>' + row
        : '<form class="nzs-ask__form"><input class="nzs-svs__in nzs-ask__in" type="text" maxlength="40" autocomplete="off" placeholder="Collection name" aria-label="Collection name" value="' + esc(o.value || '') + '">' + row + '</form>';
      panel.innerHTML =
        '<button type="button" class="nzs-qa__close" aria-label="Close"><span class="nzs-qa__close-x">&#10005;</span></button>' +
        '<div class="nzs-qa__head nzs-qa__head--noimg"><div><div class="nzs-qa__t">' + esc(o.title || '') + '</div></div></div>' +
        '<div class="nzs-qa__body">' + body + '</div>';
      panel.setAttribute('aria-label', String(o.title || 'Collection'));
    }
    function open(o, m) {
      return new Promise((res) => {
        build(); mode = m; resolve = res; render(o);
        const isSheet = window.matchMedia(MQ).matches;
        panel.classList.toggle('is-sheet', isSheet); panel.classList.toggle('nzs-qa--modal', !isSheet);
        if (overlay) overlay.open({ trigger: o.trigger || undefined });
        else { bd.classList.add('is-in'); panel.classList.add('is-in'); }
        const inp = panel.querySelector('.nzs-ask__in');
        if (inp) { inp.focus({ preventScroll: true }); if (inp.value) inp.select(); }
      });
    }
    return { text: (o) => open(o || {}, 'text'), confirm: (o) => open(o || {}, 'confirm') };
  })();

  /* ---------- /pages/favourites: chips (one per collection) + a grid per list via the Section Rendering API ---------- */
  const page = {
    active: 'favourites', sectionId: '', name: 'favourites',
    render(st, sectionId, name) {
      if (sectionId) page.sectionId = sectionId;
      if (name) page.name = name;
      const id = (s) => document.getElementById('x-saved-' + s + '-' + page.name);
      const wrap = id('inner'), empty = id('empty'), loader = id('loading'), chips = id('chips');
      if (!st.col(page.active)) page.active = st.cols[0] ? st.cols[0].k : 'favourites';
      if (chips) {
        chips.innerHTML = st.cols.map((c) => '<button type="button" class="nzs-svp__chip' + (c.k === page.active ? ' is-on' : '') + '" data-k="' + esc(c.k) + '">' + esc(c.n) + ' <b>' + c.ids.length + '</b></button>').join('') +
          '<button type="button" class="nzs-svp__chip nzs-svp__chip--new" data-new>+ New collection</button>' +
          (page.active !== 'favourites' ? '<button type="button" class="nzs-svp__tool" data-rename>Rename</button><button type="button" class="nzs-svp__tool" data-delete>Delete</button>' : '');
      }
      const col = st.col(page.active), ids = col ? col.ids : [];
      const done = (showEmpty) => { if (loader) loader.classList.add('hidden'); if (empty) empty.classList.toggle('hidden', !showEmpty); };
      const seq = page.seq = (page.seq || 0) + 1; /* every render invalidates in-flight fetches, the empty path too (Astra A) */
      if (!ids.length) { if (wrap) wrap.innerHTML = ''; done(true); return; }
      if (loader) loader.classList.remove('hidden');
      if (empty) empty.classList.add('hidden');
      const chunks = []; for (let i = 0; i < ids.length; i += 40) chunks.push(ids.slice(i, i + 40));
      Promise.all(chunks.map((ch) => fetch(Shopify.routes.root + 'search?section_id=' + encodeURIComponent(page.sectionId) + '&type=product&q=' + encodeURIComponent(ch.map((v) => 'id:' + v).join(' OR ')))
        .then((r) => (r.ok ? r.text() : '')).catch(() => '')))
        .then((parts) => {
          if (seq !== page.seq) return;
          const html = parts.map((t) => { const f = new DOMParser().parseFromString(t, 'text/html').getElementById('x-saved-inner-' + page.name); return f ? f.innerHTML : ''; }).join('');
          if (wrap) wrap.innerHTML = html;
          done(!html.trim());
        });
    }
  };
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.nzs-svp__chip[data-k], .nzs-svp__chip[data-new], .nzs-svp__tool');
    if (!chip) return;
    const st = Alpine.store('xSaved');
    if (chip.hasAttribute('data-k')) page.active = chip.getAttribute('data-k');
    /* NZS-SAVE-ASK-0906: the three native dialogs are now the in-page ask panel; each re-renders when it resolves */
    else if (chip.hasAttribute('data-new')) {
      ask.text({ title: 'New collection', cta: 'Create', trigger: chip }).then((n) => { const k = st.createList(n); if (k) { page.active = k; page.render(st); } });
    } else if (chip.hasAttribute('data-rename')) {
      const c = st.col(page.active);
      ask.text({ title: 'Rename collection', value: c ? c.n : '', cta: 'Save', trigger: chip }).then((n) => { if (n) { st.renameList(page.active, n); page.render(st); } });
    } else if (chip.hasAttribute('data-delete')) {
      ask.confirm({ title: 'Delete this collection?', body: 'The products stay in Saved if they are there too.', cta: 'Delete', danger: true, trigger: chip })
        .then((ok) => { if (ok) { st.deleteList(page.active); page.active = 'favourites'; page.render(st); } });
    }
    page.render(st);
  });

  /* ---------- PDP overlay hearts ([data-nzs-save="<pid>"]): painted from the store, saved through it ---------- */
  function paintSaveButtons() {
    const st = Alpine.store('xSaved');
    document.querySelectorAll('[data-nzs-save]').forEach((b) => {
      const on = st.has('favourites', b.getAttribute('data-nzs-save'));
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-nzs-save]');
    if (!b) return;
    e.preventDefault();
    Alpine.store('xSaved').save(b.getAttribute('data-nzs-save'), b);
  });
  document.addEventListener('eurus:saved:change', () => { paintSaveButtons(); if (document.getElementById('x-saved-chips-' + page.name)) page.render(Alpine.store('xSaved')); });
  document.addEventListener('alpine:initialized', paintSaveButtons);

  /* NZS-ALPINE-BOOT (2026-07-31): run now, not next frame - vendors.js dispatches alpine:init before the next paint, so an rAF-deferred listener randomly loses its registrations. Same fix as theme.js. */(function(_cb){_cb()})(() => {
    document.addEventListener('alpine:init', () => { try {
      Alpine.store('xSaved', {
        cols: [],
        lists: { wishlist: [], favourites: [] },
        sets: { wishlist: new Set(), favourites: new Set() },

        init() {
          this.cols = load();
          const seed = (window.Eurus && window.Eurus.savedSeed) || null;
          if (seed) {
            ['favourites', 'wishlist'].forEach((n) => (Array.isArray(seed[n]) ? seed[n] : []).map(num).filter(Boolean)
              .forEach((id) => { if (!this.cols[0].ids.includes(id)) this.cols[0].ids.push(id); }));
          }
          this._refresh(); this._persist(false);
        },
        _union() { const u = []; this.cols.forEach((c) => c.ids.forEach((id) => { if (!u.includes(id)) u.push(id); })); return u; },
        _refresh() {
          const u = this._union(), s = this.sets.favourites;
          Array.from(s).forEach((id) => { if (!u.includes(id)) s.delete(id); });
          u.forEach((id) => { if (!s.has(id)) s.add(id); });
          this.lists.favourites = u;
        },
        has(name, id) { return this.sets.favourites.has(num(id)); },
        count() { return this.sets.favourites.size; },
        ids() { return this.lists.favourites; },
        col(k) { return this.cols.find((c) => c.k === k); },
        inList(k, id) { const c = this.col(k); return !!c && c.ids.includes(num(id)); },
        add(k, id) { const c = this.col(k); id = num(id); if (!c || !id || c.ids.includes(id)) return; c.ids = [id, ...c.ids]; this._commit(id); },
        remove(k, id) { const c = this.col(k); id = num(id); if (!c) return; c.ids = c.ids.filter((x) => x !== id); this._commit(id); },
        createList(n) { n = String(n || '').trim().slice(0, 40); if (!n) return null; const k = 'c_' + Date.now().toString(36); this.cols.push({ k, n, ids: [] }); this._commit(); return k; },
        renameList(k, n) { const c = this.col(k); n = String(n || '').trim().slice(0, 40); if (c && n) { c.n = n; this._commit(); } },
        deleteList(k) { if (k === 'favourites') return; this.cols = this.cols.filter((c) => c.k !== k); this._commit(); },
        /* cards call toggle('favourites', id): a tap saves to "Saved" and opens the sheet (un-save lives in the sheet) */
        toggle(name, id) { this.save(id); },
        save(id, trigger) { id = num(id); if (!id) return; if (!this.has('favourites', id)) this.add('favourites', id); sheet.open(id, trigger || lastTrigger); },
        clear(name) { this.cols.forEach((c) => { c.ids = []; }); this._commit(); },
        _commit(id) { this._refresh(); this._persist(true, id); },
        _persist(emit, id) {
          write(KEY, { v: 2, lists: this.cols.map((c) => ({ k: c.k, n: c.n, ids: c.ids })) });
          write('eurus_favourites', this.lists.favourites);
          if (SYNC_ENDPOINT && window.Eurus && window.Eurus.customerLoggedIn) {
            try { fetch(SYNC_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ metafield: 'favourites', ids: this.lists.favourites }) }).catch(() => {}); } catch (e) {}
          }
          if (emit) document.dispatchEvent(new CustomEvent('eurus:saved:change', { detail: { list: 'favourites', id: id, ids: this.lists.favourites } }));
        },
        renderPage(sectionId, name) { page.render(this, sectionId, name); }
      });
    } catch (e) { console.error('[nzs] xSaved init failed', e); } });
  });
}
